import React from "react";
import Header from "../../../../Components/Header";
import Createpackingslip from './Createpackingslip'
import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";

const ViewPackSlip = () => {
    const location = useLocation();
  const packing_slip = location.state?.packing_slip;
  return (
    <div className='d-flex flex-column' style={{ minHeight: '100vh' }}>
      <Helmet>
				<title>Packing Slip - View</title>
			</Helmet>
      <Header />
      <div className="container-fluid maindiv d-flex flex-column " style={{flexGrow:'1'}}>
        <Createpackingslip packing_slip={packing_slip}/>
      </div>
       </div>

  );
};

export default ViewPackSlip;